import { Component, OnInit } from '@angular/core';
import { NgxNavigationWithDataComponent } from 'ngx-navigation-with-data';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ImageTrack } from 'src/app/interfaces/image-track';
import { Status } from 'src/app/interfaces/status';
import { Track } from 'src/app/interfaces/track';
import { AuthService } from 'src/app/services/auth.service';
import { DataService } from 'src/app/services/data.service';
import { FilesService } from 'src/app/services/files.service';
import { TrackingService } from 'src/app/services/tracking.service';
declare var $: any;
@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.sass']
})
export class TrackingComponent implements OnInit {
  public track:Observable<Track|null>;
  public id:string;
  public images:Observable<ImageTrack[]>;
  public status:Status[];
  public classNameStart = "li";
  public classNameProcess = "li";
  public classNameCompleted = "li";

  constructor(
    public navCtrl: NgxNavigationWithDataComponent,
    private firebaseStorage: FilesService,
    private ts: TrackingService,
    private us: AuthService,
    private dS:DataService
    ) {
      this.id = this.navCtrl.get('id');
      this.track = this.ts.getTracking(this.id).valueChanges().pipe(map(tk=>{
        if(tk != null){
          switch(tk.status){
            case "_START":
              this.classNameStart = "li complete";
              this.classNameProcess = "li";
              this.classNameCompleted = "li";
              break
            case "_PROCESS":
              this.classNameStart = "li complete";
              this.classNameProcess = "li complete";
              this.classNameCompleted = "li";
              break
            case "_COMPLETED":
                this.classNameStart = "li complete";
                this.classNameProcess = "li complete";
               this.classNameCompleted = "li complete";
                break
          }
        }
        return tk
      }));
      this.images = ts.listImageTracking(this.id).valueChanges()
      this.status = dS.DATA_STATUS
     }

  ngOnInit(): void {
    
  }

  getStatus(statusId:any):string{
    for (var _i = 0; _i < this.status.length; _i++) {
      let value:Status = this.status[_i]
      if(value.id == statusId){return value.name;}
    }
    return ""
 }


}
